const VenueFilterButton = ({ label, value }) => {
	return (
		<button
			className="wp-block-button__link venue-filter__button"
			type="button"
			data-term={value}
		>
			{label}
		</button>
	);
};

export default VenueFilterButton;
